



















import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";

import { DrivewealthWizardStep } from "@/shared/types";
import SharedAccountCreationPage from "./SharedAccountCreationPage.vue";
import RiskDisclaimer from "@/shared/components/investments/drivewealth/RiskDisclaimer.vue";
import * as RouteNames from "@/employee/route-names";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import InvestmentHeaderWithLogo from "@/shared/components/investments/drivewealth/InvestmentHeaderWithLogo.vue";
import { useDrivewealthStore } from "@/shared/store/drivewealth";

@Component({
  components: {
    SharedAccountCreationPage,
    RiskDisclaimer,
    GenericLoadingSpinner,
    InvestmentHeaderWithLogo,
  }
})
export default class AccountCreationWizardPage extends Vue {
  @Prop({ required: true })
  step: DrivewealthWizardStep; // from the url

  drivewealthStore = useDrivewealthStore();

  mounted () {
    this.drivewealthStore.resetUserAgreementDocumentKey();
  }

  get routeName () {
    return RouteNames.DrivewealthWizard;
  }

  get showQuizLogo () {
    return this.step === DrivewealthWizardStep.PortfolioSelection ||
      this.step === DrivewealthWizardStep.PortfolioConfirmation;
  }

  onWizardComplete () {
    this.$router.push({ name: RouteNames.DrivewealthSignupSweep });
  }
}
